import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

interface WhySignUpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WhySignUpModal = ({ isOpen, onClose }: WhySignUpModalProps) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    onClose();
    navigate('/auth?tab=signup');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-display font-bold text-primary">
            Why Sign Up?
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-8 py-4 font-body">
          <p className="text-base text-foreground">
            <span className="font-semibold">Start free:</span>
            <br />
            Build one event checklist with up to 25 items so you never forget a thing.
          </p>
          
          <div>
            <p className="text-base font-semibold text-foreground mb-3">
              Sign up free to unlock:
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-foreground">
                <Check className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                <span>Up to 10 events</span>
              </li>
              <li className="flex items-center gap-2 text-foreground">
                <Check className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                <span>15 checklists per event</span>
              </li>
              <li className="flex items-center gap-2 text-foreground">
                <Check className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                <span>Save and access your checklists anytime</span>
              </li>
            </ul>
          </div>
          
          <Button 
            onClick={handleSignUp}
            variant="accent"
            className="w-full h-12 text-base font-semibold rounded-sm"
          >
            Sign Up Free to Unlock More
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WhySignUpModal;
